import { createContext } from "react";
const ThemeTestProviderContext = createContext(false);
export {
  ThemeTestProviderContext
};
